// import * as types from './mutation-types';

/*export const setNewsCacheByType = function({commit},{type,data}){
	commit(types.SET_CACHE_NEWS,type,data)
}*/
import { online } from "@/api/platform";
export const getCartQuantity = function ({ commit, state }, data) {
	setTimeout(async () => {
		const { result } = await online({
			page: 1,
			limit: 100,
			keyword: '',
			select_option: '',
			form_head_uuid: 'a6cf518450fb43289af179b8beb4b943'
		})
		const total = result.reduce((sum, el) => {
			const quantity = Number(el.tbdn8rpen3ijbiv2)
			return sum + (Number.isFinite(quantity) ? quantity : 0)
		}, 0)
		state.cartNum = total
	}, 500)
}



// WEBPACK FOOTER //
// ./src/store/actions.js